module.exports = __webpack_public_path__ + "prs-preview.jpg?256925ada583183cd1fb8b04509b53d1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/prs-preview.jpg
// module id = 247
// module chunks = 0